module.exports = __webpack_public_path__ + "static/media/floppy-disk_green.784b1959.svg";